const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  userProfileData: {},
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: initialState,
  reducers: {
    setUserProfileData(state, action) {
      state.userProfileData = action.payload;
    },
  },
});

export const { setUserProfileData } = userProfileSlice.actions;

export default userProfileSlice.reducer;
